import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Formats a date-like input into "dd mon yyyy" (e.g., "12 jun 2025").
// Accepts ISO strings (including microseconds and timezone), timestamps, or Date.
export function formatDate(input, fallback = '-') {
  if (input == null || input === '') return fallback;

  let date;
  if (input instanceof Date) {
    date = input;
  } else if (typeof input === 'number') {
    date = new Date(input);
  } else if (typeof input === 'string') {
    // Normalize microseconds to milliseconds for safer cross-browser parsing
    const normalized = input.replace(/(\.\d{3})\d+/, '$1');
    date = new Date(normalized);
  } else {
    return fallback;
  }

  if (Number.isNaN(date.getTime())) return fallback;

  const day = String(date.getDate()).padStart(2, '0');
  const month = date.toLocaleString('en-US', { month: 'short' }).toLowerCase();
  const year = date.getFullYear();
  return `${day} ${month} ${year}`;
}

// A CTC value's unit (LPA vs. plain rupees) has drifted under us more than
// once, inconsistently, across different endpoints AND different records on
// the same endpoint — some candidate profiles come back with e.g. 20
// (meaning ₹20 L), others with 2000000 (the same ₹20 L in plain rupees).
// Blindly trusting one unit per endpoint (what this codebase did at first)
// silently breaks the moment a record uses the other one. No real Indian
// CTC clears a few hundred lakhs, so anything past this threshold is almost
// certainly the raw rupee figure and gets normalized down; anything at or
// under it is trusted as already being in LPA. Returns null for a missing/
// non-numeric value so callers can tell "no data" apart from "zero".
const CTC_RAW_RUPEE_THRESHOLD = 500;
export function normalizeCtcToLpa(value) {
  if (value == null || value === '') return null;
  const n = Number(value);
  if (Number.isNaN(n)) return null;
  const lakhs = n > CTC_RAW_RUPEE_THRESHOLD ? n / 100000 : n;
  return Math.round(lakhs * 10) / 10;
}
